import { Button, Form, InputGroup } from "react-bootstrap";
import { FormProps, IdType } from "../types/form";
import useInsuranceForm from "./useInsuranceForm";
import "./styles.scss";
import { fieldNames } from "../types/formConstants";
import InputField from "../inputField";
import { FC } from "react";
import DotsLoader from "../DotsLoader";
import BasicModal from "../BasicModal";

export const InsuranceForm: FC<FormProps> = ({ nextStep }) => {
  const {
    handleIdTypeChange,
    handleChange,
    canShowForm,
    handleClose,
    isLoading,
    idType,
    formik,
    text,
    show,
  } = useInsuranceForm(nextStep);

  return (
    <Form onSubmit={formik.handleSubmit}>
      <div className="mb-3 d-flex flex-column justify-content-center align-items-center">
        <div className="col-sm-6 col-12">
          <InputGroup className="mb-2">
            <InputGroup.Text>Identificación</InputGroup.Text>
            <Form.Select
              name="idType"
              value={formik.values.idType}
              onChange={(e) => handleIdTypeChange(e)}
            >
              {Object.entries(IdType).map(([key, value]) => (
                <option key={key} value={value}>
                  {value}
                </option>
              ))}
            </Form.Select>
          </InputGroup>
          <InputField
            id="form-idNumber"
            className="mb-2"
            type="text"
            name="idNumber"
            formik={formik}
            label={`${fieldNames[idType].idNumber} *`}
            handleChange={handleChange}
          />
          {canShowForm() ? (
            <>
              <InputField
                id="form-name"
                className="mb-2"
                type="text"
                name="name"
                formik={formik}
                label={`${fieldNames[idType].name} *`}
              />
              <InputField
                id="form-firstLastName"
                className="mb-2"
                type="text"
                name="firstLastName"
                formik={formik}
                label="Primer Apellido *"
              />
              <InputField
                id="form-secondLastName"
                className="mb-2"
                type="text"
                name="secondLastName"
                formik={formik}
                label="Segundo Apellido"
              />
            </>
          ) : (
            isLoading && <DotsLoader text="Cargando datos del padrón" />
          )}
          <InputField
            id="form-email"
            className="mb-2"
            type="text"
            name="email"
            formik={formik}
            label="Correo *"
          />
          <InputField
            id="form-phone"
            className="mb-2"
            type="number"
            name="phone"
            formik={formik}
            label="Teléfono *"
            handleChange={handleChange}
          />
          <InputField
            id="form-company"
            className="mb-2"
            type="text"
            name="company"
            formik={formik}
            label="Empresa"
          />
          <div className="required-space">* Espacios obligatorios</div>
          <div className="d-flex flex-row justify-content-end my-3">
            <Button
              type="submit"
              className="btn-width"
              disabled={!formik.isValid}
            >
              Siguiente
            </Button>
          </div>
        </div>
      </div>
      <BasicModal show={show} handleClose={handleClose} text={text} />
    </Form>
  );
};
